import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Burger from "./Burger";

import { AuthContext } from "../../context/auth.context";
import { getAuth, signOut } from "firebase/auth";

import logo from "../../images/logo Nav.png";
import logoUser from "../../images/user_icon.svg";

// ===== STYLED COMPONENTS =====

const Nav = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  height: 60px;
  /* Degradado Disney / El Reto de Carmen */
  background: linear-gradient(90deg, #f8c9d9 0%, #e0c3fc 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  /* Clases para ocultar/mostrar con scroll */
  &.nav-hide {
    transform: translateY(-100%);
  }

  &.nav-show {
    transform: translateY(0);
  }
`;

const Logo = styled.div`
  img {
    height: 35px; /* Un poco más grande para legibilidad */
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  a {
    text-decoration: none;
    color: #9c4d97; /* Rosa fuerte/Violeta definido */
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: color 0.3s ease;

    &:hover {
      color: #7a3075;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileControls = styled.div`
  display: none;
  align-items: center;
  gap: 12px; 

  img {
    width: 30px;
    height: 30px;
    display: block;
    /* Filtro opcional para que el icono de usuario sea del color del tema */
    filter: invert(41%) sepia(54%) saturate(542%) hue-rotate(256deg) brightness(88%) contrast(88%);
  }

  @media (max-width: 1024px) {
    display: flex;
  }
`;

// ===== COMPONENTE PRINCIPAL =====

const Navbar = () => {
  const navigate = useNavigate();
  const { isLoggedIn, isAdmin, authenticateUser } = useContext(AuthContext);

  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;

      // 1. Si estamos arriba del todo (o valores negativos de rebote en móvil), mostrar siempre
      if (currentScrollY <= 10) {
        setShowNav(true);
        setLastScrollY(currentScrollY);
        return;
      }

      // 2. Umbral de tolerancia: No hacer nada si el movimiento es mínimo (evita vibraciones)
      if (Math.abs(currentScrollY - lastScrollY) < 15) {
        return;
      }

      // 3. Lógica de dirección
      if (currentScrollY > lastScrollY) {
        // Scroll hacia abajo -> Ocultar
        setShowNav(false);
      } else {
        // Scroll hacia arriba -> Mostrar
        setShowNav(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", controlNavbar);
    return () => window.removeEventListener("scroll", controlNavbar);
  }, [lastScrollY]);

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        authenticateUser();
        navigate("/");
        console.log("Usuario deslogueado");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Nav className={showNav ? "nav-show" : "nav-hide"}>
      {/* Izquierda - Logo */}
      <Logo>
        <Link to="/">
          <img src={logo} style={{ width: "70px", height:"60px" }} alt="El Reto de Carmen" />
        </Link>
      </Logo>

      {/* Centro - Desktop Links */}
      <NavLinks>
        <Link to="/">Home</Link>
        <Link to="/el-reto">El Reto</Link>
        <Link to="/conoce-a-carmen">Carmen</Link>
        <Link to="/retos-anteriores">Anteriores</Link>
        <Link to="/rutas-bicicletas">Rutas</Link>
        <Link to="/colabora">Colabora</Link>
        <Link to="/colaboradores">Colaboradores</Link>
        <Link to="/contacto">Contacto</Link>
        {/* <Link to="/gregarios">Gregarios</Link> */}
        
        {isAdmin && <Link to="/admin">Admin</Link>}
        {isLoggedIn && (
          <Link to="/" onClick={handleLogout} style={{ color: '#ff4d4d' }}>
            Salir
          </Link>
        )}
      </NavLinks>

      {/* Derecha - Mobile Controls */}
      <MobileControls>
        {isAdmin && (
          <Link to="/admin">
            <img src={logoUser} alt="User Admin" />
          </Link>
        )}
        <Burger />
      </MobileControls>
    </Nav>
  );
};

export default Navbar;